import State from 'store/State';
import { selectWidgetInstancesState } from 'widgets/store/selectors';
import { WidgetType } from 'widgets/WidgetType';

export const selectOutliersWidgetsState = (state: State) =>
    selectWidgetInstancesState(state)[WidgetType.OUTLIERS_WIDGET];

export const selectOutliersWidgetState = (state: State, widgetKey: string) =>
    selectOutliersWidgetsState(state)[widgetKey];
